import React from "react";
import { MED_STATUS_LABEL, MED_STATUS_TONE, medStatusOfView, type MedStatus } from "../server/station/med-status";

/**
 * THE medication status badge (M3 Stage 3 fix 1): one badge per medication,
 * from the one status function the server's reports use too. Never shown
 * beside another status badge for the same medication.
 */
export function MedStatusBadge({ m, status }: { m?: Parameters<typeof medStatusOfView>[0]; status?: MedStatus }): React.ReactElement {
  const s = status ?? medStatusOfView(m);
  return <span className={`rounded px-1.5 py-0.5 text-xs font-medium ${MED_STATUS_TONE[s]}`}>{MED_STATUS_LABEL[s]}</span>;
}
